import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const TheAqueduct = {
  id: '156',
  name: "The Aqueduct",
  width: 6,
  height: 2,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'The_Aqueduct',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/The_Aqueduct',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,152,154,156
        ],
        bronzeAge: [
          57,60,63,66,69,72,75,78,81,84,87,90,93,96,99,102,105,108,111,114,117,120,123,126,129,132,135,138,141,144,147,150,153,156,159,162,165,168,171,174,177,180,183,186,189,192,195,198,201,204,207,210,213,216,219,222,225,228,231,234
        ],
        minoanEra: [
          76,80,84,88,92,96,100,104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312
        ],
        classicGreece: [
          95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380,385,390
        ],
        earlyRome: [
          114,120,126,132,138,144,150,156,162,168,174,180,186,192,198,204,210,216,222,228,234,240,246,252,258,264,270,276,282,288,294,300,306,312,318,324,330,336,342,348,354,360,366,372,378,384,390,396,402,408,414,420,426,432,438,444,450,456,462,468
        ],
        romanEmpire: [
          133,140,147,154,161,168,175,182,189,196,203,210,217,224,231,238,245,252,259,266,273,280,287,294,301,308,315,322,329,336,343,350,357,364,371,378,385,392,399,406,413,420,427,434,441,448,455,462,469,476,483,490,497,504,511,518,525,532,539,546
        ],
        byzantineEra: [
          152,160,168,176,184,192,200,208,216,224,232,240,248,256,264,272,280,288,296,304,312,320,328,336,344,352,360,368,376,384,392,400,408,416,424,432,440,448,456,464,472,480,488,496,504,512,520,528,536,544,552,560,568,576,584,592,600,608,616,624
        ],
        ageOfTheFranks: [
          171,180,189,198,207,216,225,234,243,252,261,270,279,288,297,306,315,324,333,342,351,360,369,378,387,396,405,414,423,432,441,450,459,468,477,486,495,504,513,522,531,540,549,558,567,576,585,594,603,612,621,630,639,648,657,666,675,684,693,702
        ],
        feudalAge: [
          190,200,210,220,230,240,250,260,270,280,290,300,310,320,330,340,350,360,370,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620,630,640,650,660,670,680,690,700,710,720,730,740,750,760,770,780
        ],
        iberianEra: [
          209,220,231,242,253,264,275,286,297,308,319,330,341,352,363,374,385,396,407,418,429,440,451,462,473,484,495,506,517,528,539,550,561,572,583,594,605,616,627,638,649,660,671,682,693,704,715,726,737,748,759,770,781,792,803,814,825,836,847,858
        ],
        kingdomOfSicily: [
          228,240,252,264,276,288,300,312,324,336,348,360,372,384,396,408,420,432,444,456,468,480,492,504,516,528,540,552,564,576,588,600,612,624,636,648,660,672,684,696,708,720,732,744,756,768,780,792,804,816,828,840,852,864,876,888,900,912,924,936
        ],
        highMiddleAges: [
          247,260,273,286,299,312,325,338,351,364,377,390,403,416,429,442,455,468,481,494,507,520,533,546,559,572,585,598,611,624,637,650,663,676,689,702,715,728,741,754,767,780,793,806,819,832,845,858,871,884,897,910,923,936,949,962,975,988,1001,1014
        ],
        earlyGothicEra: [
          266,280,294,308,322,336,350,364,378,392,406,420,434,448,462,476,490,504,518,532,546,560,574,588,602,616,630,644,658,672,686,700,714,728,742,756,770,784,798,812,826,840,854,868,882,896,910,924,938,952,966,980,994,1008,1022,1036,1050,1064,1078,1092
        ],
        lateGothicEra: [
          285,300,315,330,345,360,375,390,405,420,435,450,465,480,495,510,525,540,555,570,585,600,615,630,645,660,675,690,705,720,735,750,765,780,795,810,825,840,855,870,885,900,915,930,945,960,975,990,1005,1020,1035,1050,1065,1080,1095,1110,1125,1140,1155,1170
        ]
      }),
      CultureRange.asCallbackWithLevel(
        (level) => {
          if (level < 30) {
            return 1;
          }
          if (level < 60) {
            return 2;
          }
          return 3;
        }
      ),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          36,40,43,47,50,54,57,61,64,68,71,75,78,82,85,89,92,96,99,103,106,110,113,117,120,124,127,131,134,138,141,145,148,152,155,159,162,166,169,173,176,180,183,187,190,194,197,201,204,208,211,215,218,222,225,229,232,236,239,243
        ],
        bronzeAge: [
          36,40,43,47,50,54,57,61,64,68,71,75,78,82,85,89,92,96,99,103,106,110,113,117,120,124,127,131,134,138,141,145,148,152,155,159,162,166,169,173,176,180,183,187,190,194,197,201,204,208,211,215,218,222,225,229,232,236,239,243
        ],
        minoanEra: [
          46,50,54,58,62,66,70,74,78,82,86,90,94,98,102,106,110,114,118,122,126,130,134,138,142,146,150,154,158,162,166,170,174,178,182,186,190,194,198,202,206,210,214,218,222,226,230,234,238,242,246,250,254,258,262,266,270,274,278,282
        ],
        classicGreece: [
          55,60,64,69,73,78,82,87,91,96,100,105,109,114,118,123,127,132,136,141,145,150,154,159,163,168,172,177,181,186,190,195,199,204,208,213,217,222,226,231,235,240,244,249,253,258,262,267,271,276,280,285,289,294,298,303,307,312,316,321
        ],
        earlyRome: [
          65,70,75,80,85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360
        ],
        romanEmpire: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        byzantineEra: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        ageOfTheFranks: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        feudalAge: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        iberianEra: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        kingdomOfSicily: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        highMiddleAges: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        earlyGothicEra: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ],
        lateGothicEra: [
          74,80,85,91,96,102,107,113,118,124,129,135,140,146,151,157,162,168,173,179,184,190,195,201,206,212,217,223,228,234,239,245,250,256,261,267,272,278,283,289,294,300,305,311,316,322,327,333,338,344,349,355,360,366,371,377,382,388,393,399
        ]
      }).withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS),
    ),
    new PassiveAura(
      PassiveAuraType.LIGHT_INFANTRY_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        1.00, 1.00, 1.25, 1.25, 1.25, 1.25, 1.75, 1.75, 2.00, 2.00,
        2.25, 2.25, 2.50, 2.50, 2.50, 2.50, 3.00, 3.00, 3.25, 3.25,
        3.50, 3.50, 3.75, 3.75, 3.75, 3.75, 4.25, 4.25, 4.50, 4.50,
        4.75, 4.75, 5.00, 5.00, 5.00, 5.00, 5.50, 5.50, 5.75, 5.75,
        6.00, 6.00, 6.25, 6.25, 6.25, 6.25, 6.75, 6.75, 7.00, 7.00,
        7.25, 7.25, 7.50, 7.50, 7.50, 7.50, 8.00, 8.00, 8.25, 8.25,
      ]),
      '%',
    ),
  ]),
};

export default TheAqueduct;
